import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useLayoutStore = defineStore('layout', () => {
  const isMobileHeaderDisplayed = ref(true);

  const hideMobileHeader = () => {
    isMobileHeaderDisplayed.value = false;
  };

  const showMobileHeader = () => {
    isMobileHeaderDisplayed.value = true;
  };

  return {
    isMobileHeaderDisplayed,
    hideMobileHeader,
    showMobileHeader,
  };
});
